<template>
  <div class="qr-main">
    <div class="qr-container">
      <div class="qr-container-head">
        <div class="card-logo-group">
          <div class="logo"><img src="../../public/img/xz-logo.png" /></div>
          <div class="card-title">{{ couponDetail.ProductName }}</div>
        </div>
        <div v-if="refundFlag" class="check-out-btn" @click="refundTicket()">
          退款
        </div>
        <img :src="couponDetail.CoverPictureUri" />
        <div class="card-foot">
          <div class="card-time">
            <span class="time-field">有效期</span>
            <template v-if="couponDetail.timeStatus == '未生效'">
              <span class="time">未生效</span>
            </template>
            <template v-if="couponDetail.timeStatus == ''">
              <span
                class="time"
                v-if="
                  (couponDetail.TicketType === 4 &&
                    (couponDetail.Status != 20 || couponDetail.Status != 30)) ||
                  couponDetail.Status === 30
                "
                >{{
                  couponDetail.ExpirationTime
                    ? couponDetail.ExpirationTime.replace("T", " ")
                    : "-"
                }}</span
              >
              <span
                class="time"
                v-if="
                  (couponDetail.TicketType === 1 ||
                    couponDetail.TicketType === 2 ||
                    couponDetail.TicketType === 3 ||
                  couponDetail.TicketType === 5) &&
                  couponDetail.Status === 20
                "
                >未激活</span
              >
              <span
                class="time"
                v-if="couponDetail.Status != 20 && couponDetail.Status != 30"
                >已失效</span
              >
            </template>
          </div>
          <div class="card-number">
            <span class="number-field">剩余可乘车</span>
            <span class="number">{{
              couponDetail.RemainingCount ? couponDetail.RemainingCount : "-"
            }}</span>
            <span class="number-field">次</span>
          </div>
        </div>
      </div>
      <div class="qr-container-body" v-if="couponDetail.timeStatus == '未生效'">
        <div class="qr-test">票卡未生效，暂不可用</div>
        <div class="canvas">

          <!-- <qr-code
            :text="qrCodeSrc"
            class="qr_pic"
            v-show="guid && qrCodeSrc"
            error-level="L"
          ></qr-code> -->
          <img src="../../public/img/img_qrcode_none.png" />
          <!-- <div class="qrCode-logo" v-show="qrCodeSrc">
            <img src="../../public/img/xz-logo.png" />
          </div> -->
        </div>
        <div class="qr-tag-1">
          有效期：{{
            couponDetail.EffectiveTime + "至" + couponDetail.ExpirationTime
          }}
        </div>
        <!-- <a class="refreshQrCode" @click="refreshQrCode()">刷新二维码</a> -->
      </div>

      <div class="qr-container-body" v-if="couponDetail.timeStatus == ''">
        <div class="qr-test">请将二维码对准闸机扫描口扫码过闸</div>
        <div class="canvas" @click="refreshQrCode()">
          <qr-code
            :text="qrCodeSrc"
            class="qr_pic"
            v-show="guid && qrCodeSrc"
            error-level="L"
          ></qr-code>
          <img src="../../public/img/img_qrcode_none.gif" v-show="!qrCodeSrc" />
          <div class="qrCode-logo" v-show="qrCodeSrc">
            <img src="../../public/img/xz-logo.png" />
          </div>
        </div>
        <div class="qr-tag">扫码建议高度5cm以上</div>
        <a class="refreshQrCode" @click="refreshQrCode()">刷新二维码</a>
      </div>
    </div>
    <div class="foot-box">
      <div class="qr-help" @click="openHelper()">
        <div class="qr-group">
          <div class="icon-btn"><img src="img/icon-help-btn.png" /></div>
          <div class="btn-text">使用说明</div>
        </div>
      </div>
      <div class="card-list" @click="gotoMyTickets()">
        <div class="qr-group">
          <div class="icon-btn"><img src="img/icon-card-btn.png" /></div>
          <div class="btn-text">我的车票</div>
        </div>
      </div>
    </div>
    <!--退卡-->
    <div class="mask" v-show="refundBox">
      <div class="alert-box">
        <div class="alert-head">
          <img src="img/icon-close.png" @click="cancleRefund()" />
        </div>
        <div class="alert-title">你是否要确认退卡</div>
        <div class="alert-msg">退卡后需要再次购买才能使用</div>
        <div class="alert-btn-box">
          <div class="alert-btn" @click="cancleRefund()">我再想想</div>
          <div class="alert-btn btn-true" @click="refund()">确认退卡</div>
        </div>
      </div>
    </div>
    <!--    无法退款-->
    <div class="mask" v-show="noRefundBox">
      <div class="alert-box">
        <div class="alert-msg">已激活票卡无法退款</div>
        <div
          class="alert-btn-box"
          style="display: flex; justify-content: center; align-items: center"
        >
          <div class="alert-btn btn-true" @click="noRefundKnow()">我知道了</div>
        </div>
      </div>
    </div>
    <div class="maskAlart" v-show="refundingStatusShow">
      <div class="alert-box">
        <div class="alert-msg">
          <span>退款中···</span>
          <div class="mdui-spinner loading"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'vue-qrcode-component'
import util from '../utils/util'

const QR_CACHE_PREFIX = 'ListQRCodeDetail'
const QR_CACHE_TTL = 25000

export default {
  name: 'preview',
  components: { QRCode },
  data () {
    return {
      guid: '',
      qrCodeSrc: '',
      couponDetail: {},
      interval: -1,
      validInterval: -1,
      refundFlag: false,
      refundBox: false,
      noRefundBox: false,
      isRefunding: false,
      refundingStatusShow: false
    }
  },
  mounted () {
    this.mdui.mutation()
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    this.guid = this.resolveGuid()
    this.startPolling(true)
  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    this.stopPolling()
  },
  methods: {
    resolveGuid () {
      return this.$route.query.guid || window.sessionStorage.getItem('GuidCoupon') || ''
    },
    getQRCodeCacheKey (guid = this.guid) {
      return `${QR_CACHE_PREFIX}${guid}`
    },
    stopQRCodePolling () {
      if (this.interval > 0) {
        clearInterval(this.interval)
        this.interval = -1
      }
    },
    stopCouponValidPolling () {
      if (this.validInterval > 0) {
        clearInterval(this.validInterval)
        this.validInterval = -1
      }
    },
    stopPolling () {
      this.stopQRCodePolling()
      this.stopCouponValidPolling()
    },
    startPolling (forceRefresh = false) {
      this.guid = this.resolveGuid()
      if (!this.guid) {
        this.handleMissingGuid()
        return
      }

      this.stopPolling()
      this.getCouponGuid()

      if (forceRefresh) {
        this.refreshQrCode()
      } else {
        this.getQRCode()
      }

      this.interval = setInterval(() => this.getQRCode(), 20000)
      this.validInterval = setInterval(() => this.getCouponValid(), 3000)
    },
    clearQRCodeCache (guid = this.guid) {
      if (!guid) return
      this.util.removeRuntimeCache(this.getQRCodeCacheKey(guid))
    },
    handleMissingGuid () {
      this.stopPolling()
      this.qrCodeSrc = ''
      this.mdui.dialog({
        history: false,
        title: '提示',
        content: '此票卡不存在，请重新选择票卡',
        buttons: [
          {
            text: '确认',
            onClick: () => {
              setTimeout(() => {
                this.$router.push({
                  path: '/cardslist',
                  query: this.$route.query
                })
              }, 200)
            }
          }
        ]
      })
    },
    handleVisibilityChange () {
      if (document.hidden) {
        this.stopPolling()
        return
      }

      this.startPolling(true)
    },
    refreshQrCode () {
      if (!this.guid) {
        this.handleMissingGuid()
        return
      }
      this.clearQRCodeCache()
      this.qrCodeSrc = ''
      this.requestQRCode()
    },
    getCouponValid () {
      let url = '/itps/api/coupon/valid'
      let curGuid = this.guid
      let target = ''
      if (this.guid.startsWith('extp_')) {
        url = '/exapi/extp/api/h5/voucher/valid'
        curGuid = this.guid.replace('extp_', '')
        target = 'extp'
      }
      this.$axios
        .post(url, { Guid: curGuid }, target) // this.guid
        .then((data) => {
          if (data) {
            if (data.Code === 200) {
              if (!data.Data.Valid) {
                this.stopPolling()
                this.clearQRCodeCache()
                this.qrCodeSrc = ''
              }
            }
          }
        })
        .catch((e) => console.log(e))
    },
    getCouponGuid () {
      if (!this.guid) return
      this.$axios
        .post('/qca/ticket/detail', { GuidCoupon: this.guid }, 'ticket') // this.guid
        .then((data) => {
          if (data) {
            if (data.Code === 200) {
              if (
                (data.Data.TicketType === 1 || data.Data.TicketType === 2 || data.Data.TicketType === 3 || data.Data.TicketType === 5) && data.Data.Status === 20
              ) {
                this.refundFlag = true
              } else {
                this.refundFlag = false
              }
              this.couponDetail = data.Data
              var curDate = new Date()
              // 时间-转成/
              var begainDate = new Date(data.Data.EffectiveTime.replace(/-/g, '/'))
              if (curDate < begainDate) {
                this.couponDetail.timeStatus = '未生效'
              } else {
                this.couponDetail.timeStatus = ''
              }
            } else if (data.Code === -404) {
            } else {
              if (data.Message) {
                this.mdui.snackbar({
                  message: data.Message,
                  position: 'bottom'
                })
              }
            }
          }
        })
        .catch((e) => console.log(e))
    },
    requestQRCode () {
      if (!this.guid) return
      this.$axios
        .post('/qca/qr/build', { GuidCoupon: this.guid }, 'ticket') // this.guid
        .then((data) => {
          if (data) {
            if (data.Code === 200) {
              const date1 = new Date(data.Data.TimeBeginBuild.replace(/-/g, '/'))
              if (!this.util.isValidDate(date1)) {
                console.log('格式化时间错误！')
                return
              }
              const diffTimeMs = date1 - new Date()
              this.util.setRuntimeCache(this.getQRCodeCacheKey(), {
                guid: this.guid,
                data: data.Data.ListQRCodeDetail,
                diffTimeMs,
                expiresAt: Date.now() + QR_CACHE_TTL
              })
              this.makeQRCode(data.Data.ListQRCodeDetail, diffTimeMs)
            } else if (data.Code === -404) {
            } else if (data.Code === 4700) {
            } else {
              if (data.Message) {
                this.mdui.snackbar({
                  message: data.Message,
                  position: 'bottom'
                })
              }
            }
          }
        })
        .catch((e) => console.log(e))
    },
    getQRCode () {
      this.guid = this.resolveGuid()
      if (!this.guid) {
        this.handleMissingGuid()
        return
      }

      const cacheQRCode = this.util.getRuntimeCache(this.getQRCodeCacheKey())
      if (!cacheQRCode || cacheQRCode.guid !== this.guid || cacheQRCode.expiresAt <= Date.now()) {
        this.requestQRCode()
        return
      }

      this.makeQRCode(cacheQRCode.data, cacheQRCode.diffTimeMs)
    },
    makeQRCode (qrList, diffTimeMs) {
      const serverDiffTimeMs = Number(diffTimeMs) || 0
      let hasAvailableQRCode = false
      for (let i = 0; i < qrList.length; i++) {
        const date1 = new Date(qrList[i].TimeInvalid.replace(/-/g, '/'))
        if (!this.util.isValidDate(date1)) {
          console.log('格式化时间错误！')
          return
        }
        if (date1 - new Date() > serverDiffTimeMs) {
          this.qrCodeSrc = qrList[i].Content
          hasAvailableQRCode = true
          break
        }
      }
      if (!hasAvailableQRCode) {
        this.requestQRCode()
      }
    },
    openHelper () {
      util.addmatomo(
        'qrcode_myticket_detail_explain_click_event',
        'qrcode_myticket_detail_explain_click_event',
        1
      )
      this.$router.push({ path: '/help', query: this.$route.query })
    },
    gotoMyTickets () {
      util.addmatomo(
        'qrcode_my_ticket_click_event',
        'qrcode_my_ticket_click_event',
        1
      )
      this.stopPolling()
      this.$router.back()
    },
    refundTicket () {
      if (
        (this.couponDetail.TicketType === 1 ||
          this.couponDetail.TicketType === 2 ||
          this.couponDetail.TicketType === 3 ||
        this.couponDetail.TicketType === 5) &&
        this.couponDetail.Status === 20
      ) {
        if (!this.refundBox) {
          this.refundBox = true
        }
      } else {
        if (!this.noRefundBox) {
          this.noRefundBox = true
        }
      }
    },
    noRefundKnow () {
      this.noRefundBox = false
    },
    refund () {
      var self = this
      if (!self.isRefunding) {
        self.isRefunding = true
        self.cancleRefund()
        self.openRefundStatus()
        self.$axios
          .post('/qca/order/refund', { GuidCoupon: self.guid }, 'ticket')
          .then((data) => {
            self.closeRefundStatus()
            if (data) {
              if (data.Code === 200) {
                if (data.Data) {
                  if (data.Data.Status === 760) {
                    self.mdui.snackbar({
                      message: data.Data.Message,
                      position: 'bottom'
                    })
                  } else if (
                    data.Data.Status === 770 ||
                    data.Data.Status === 750
                  ) {
                    self.stopPolling()
                    self.clearQRCodeCache()
                    self.qrCodeSrc = ''
                    self.mdui.alert(
                      '退款申请已提交，票款将在3个工作日内原路退回您的支付账号，请留意查收',
                      function () {
                        self.$router.back()
                      },
                      {
                        history: false,
                        modal: true,
                        closeOnEsc: false
                      }
                    )
                  }
                }
              } else if (data.Code === 4810) {
                if (data.Message) {
                  self.mdui.snackbar({
                    message: '退票失败,请重试',
                    position: 'bottom'
                  })
                }
              } else if (data.Code === 4811) {
                if (data.Message) {
                  self.mdui.snackbar({
                    message: '退票失败,票卡不存在或已过期',
                    position: 'bottom'
                  })
                }
              } else if (data.Code === 4812) {
                if (data.Message) {
                  self.mdui.snackbar({
                    message: '退票失败,票卡已使用',
                    position: 'bottom'
                  })
                }
              } else if (data.Code === 4813) {
                if (data.Message) {
                  self.mdui.snackbar({
                    message: '退票失败,票卡退票中',
                    position: 'bottom'
                  })
                }
              } else {
                if (data.Message) {
                  self.mdui.snackbar({
                    message: data.Message,
                    position: 'bottom'
                  })
                }
              }
            }
            self.isRefunding = false
          })
          .catch((e) => console.log(e))
      } else {
        self.mdui.snackbar({
          message: '重复请求',
          position: 'bottom'
        })
      }
    },
    cancleRefund () {
      this.refundBox = false
    },
    openRefundStatus () {
      this.refundingStatusShow = true
    },
    closeRefundStatus () {
      this.refundingStatusShow = false
    }
  }
}
</script>

<style>
.qr-main .qr_pic {
  width: 200px;
  margin: 0 auto;
}
.qr-main .qr_pic img {
  width: 200px;
}
</style>

<style scoped>
.refreshQrCode {
  display: inline-block;
  margin-top: 10px;
  border: 1px solid #e5e5e5;
  padding: 5px 5px;
  border-radius: 3px;
  color: #666666;
}
.qr-main {
  height: 100%;
  background-color: #f5f5f5;
}
.qr-container {
  margin: 0 auto;
  padding: 0;
  margin-top: 15px;
  width: 94%;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.18);
}
.qr-container-head {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 4px 4px 0 0;
}
.qr-container-head img {
  width: 100%;
}
.card-foot {
  position: absolute;
  bottom: 0;
  height: 21.25%;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
}
.card-foot .card-time,
.card-foot .card-number {
  display: block;
  height: 20px;
  line-height: 20px;
  position: absolute;
  top: 50%;
  margin-top: -10px;
  font-size: 1.2rem;
}
.card-foot .card-time {
  left: 10px;
}
.time-field,
.number-field {
  color: #ffffff;
  opacity: 0.5;
}
.card-time .time {
  color: #ffffff;
  margin-left: 5px;
}
.card-foot .card-number {
  right: 10px;
}
.number {
  color: #ffffff;
  font-weight: bold;
  font-size: 1.7rem;
  margin: 0 5px;
}
.card-logo-group {
  overflow: hidden;
  height: 24px;
  position: absolute;
  left: 15px;
  top: 15px;
}
.card-logo-group .logo {
  width: 24px;
  height: 24px;
  float: left;
}
.card-logo-group .card-title {
  height: 24px;
  line-height: 24px;
  font-size: 1.7rem;
  font-weight: bold;
  float: left;
  color: #ffffff;
  margin-left: 5px;
}
.check-out-btn {
  position: absolute;
  height: 24px;
  font-size: 1.5rem;
  color: #ffffff;
  background-color: #b93741;
  width: 60px;
  height: 28px;
  text-align: center;
  line-height: 28px;
  border-radius: 4px;
  right: 15px;
  top: 13px;
}

.qr-container-body {
  background-color: #ffffff;
  padding-top: 20px;
  padding-bottom: 20px;
}
.canvas {
  width: 200px;
  height: 200px;
  margin: 0 auto;
  position: relative;
}
.canvas img {
  width: 100%;
}

.qr-test {
  text-align: center;
  font-size: 1.6rem;
  font-weight: bold;
  color: #cc9d9d;
  margin-bottom: 15px;
}
.qr-tag {
  background-color: #fde2e5;
  color: #ba3541;
  font-size: 1.5rem;
  text-align: center;
  border-radius: 2px;
  height: 32px;
  line-height: 32px;
  width: 198px;
  margin: 0 auto;
  margin-top: 10px;
}
.qr-tag-1 {
  background-color: #f5f5f5;
  color: #000;
  font-size: 1.5rem;
  text-align: center;
  border-radius: 2px;
  /* height: 32px;
  line-height: 32px; */
  margin: 0 auto;
  margin-top: 10px;
  padding: 10px;
}
.foot-box {
  width: 94%;
  margin: 0 auto;
  margin-top: 10px;
}
.qr-help {
  float: left;
  width: calc(50% - 5px);
  background-color: #ffffff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.18);
  text-align: center;
  height: 50px;
}
.card-list {
  float: right;
  width: calc(50% - 5px);
  background-color: #ffffff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.18);
  text-align: center;
  height: 50px;
}
.qr-group {
  overflow: hidden;
  display: inline-block;
  margin-top: 10px;
}
.icon-btn,
.btn-text {
  float: left;
}
.btn-text {
  font-size: 1.6rem;
  margin-left: 5px;
  height: 30px;
  line-height: 30px;
}
.icon-btn {
  width: 30px;
  height: 30px;
}
.icon-btn img {
  width: 100%;
}
.mask,
.maskAlart {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.mask {
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.7);
}
.maskAlart {
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.2);
}

.mask .alert-box,
.maskAlart .alert-box {
  padding: 10px 15px;
  border-radius: 5px;
  position: fixed;
  top: 50%;
  left: 50%;
}
.mask .alert-box {
  background-color: #ffffff;
  width: 240px;
  margin-top: -77.5px;
  margin-left: -135px;
  display: flex;
  flex-direction: column;
}
.maskAlart .alert-box {
  background-color: rgba(0, 0, 0, 0.85);
  width: 80px;
  height: 80px;
  margin-top: -50px;
  margin-left: -55px;
  border-radius: 10px;
}
.maskAlart .alert-box span {
  color: #fff;
  font-size: 15px;
  display: block;
  padding-bottom: 5px;
}
.alert-msg {
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: center;
  font-size: 1.6rem;
  color: #666666;
}
.alert-btn-box {
  overflow: hidden;
  margin-top: 15px;
  margin-bottom: 15px;
}
.alert-btn {
  float: left;
  width: calc(50% - 5px);
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 17px;
  color: #ffffff;
  background-color: #999999;
  border-radius: 5px;
  margin: 0 auto;
}
.btn-true {
  float: right;
  color: #ffffff;
  background-color: #b93741;
}
.alert-head {
  height: 15px;
}
.alert-head img {
  width: 15px;
  height: 15px;
  float: right;
}
.alert-title {
  font-size: 1.7rem;
  font-weight: bold;
  text-align: center;
  margin-top: 10px;
}
.qrCode-logo {
  position: absolute;
  position: 999;
  top: 50%;
  left: 50%;
  margin-top: -20px;
  margin-left: -20px;
  background-color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 3px;
}
@media screen and (max-height: 590px) {
  .qr-container-body {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .qr-test {
    font-size: 1.4rem;
    margin-bottom: 5px;
  }
  .canvas {
    width: 180px;
    height: 180px;
    margin: 0 auto;
  }
  canvas {
    width: 180px;
    height: 180px;
    margin: 0 auto;
  }
}
@media screen and (min-height: 700px) {
  .qr-container-body {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  .card-list,
  .qr-help {
    height: 70px;
  }
  .qr-group {
    margin-top: 15px;
  }
  .btn-text {
    font-size: 1.6rem;
    height: 40px;
    line-height: 40px;
  }
  .icon-btn {
    width: 40px;
    height: 40px;
  }
}
</style>
